var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlluConfirmation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 518,
    height: 243,
    viewBox: "0 0 518 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7445 155.489C18.2308 155.489 23.489 150.231 23.489 143.744C23.489 137.258 18.2308 132 11.7445 132C5.25818 132 0 137.258 0 143.744C0 150.231 5.25818 155.489 11.7445 155.489Z",
    fill: "#FA8CB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M474.744 120.489C481.231 120.489 486.489 115.231 486.489 108.744C486.489 102.258 481.231 97 474.744 97C468.258 97 463 102.258 463 108.744C463 115.231 468.258 120.489 474.744 120.489Z",
    fill: "#A8E58B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M108 242.146C144.218 215.923 176.071 180.003 176.071 210.051C176.071 240.1 163.516 234.483 186.981 217.314C229.814 185.963 237.643 193.27 260.899 211.983C295.357 239.712 371.46 206.264 417.444 180.098C458.536 156.715 519.529 144.35 517.941 172.27C516.225 202.426 514.764 242.165 514.764 242.165L108 242.146Z",
    fill: "#E6F3F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.437 76.4388C220.267 76.4388 220.939 75.7662 220.939 74.9364C220.939 74.1067 220.267 73.4341 219.437 73.4341C218.607 73.4341 217.935 74.1067 217.935 74.9364C217.935 75.7662 218.607 76.4388 219.437 76.4388Z",
    fill: "#8A7CB2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M214.543 96.254C250.26 86.3514 251.321 86.8817 251.321 86.8817L261.047 115.003L244.251 146.474L230.297 150.544L212.622 96.9657L214.543 96.254Z",
    fill: "#E6F2F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M215.906 98.5514C221.139 95.0955 249.535 88.1278 250.112 88.5139C250.688 88.8999 259.07 112.887 259.07 112.887C258.977 113.947 261.577 113.273 261.289 111.249C261 109.226 256.954 98.5374 256.665 96.9978C256.377 95.4582 252.33 84.765 251.084 84.5743C249.837 84.3836 236.446 86.5976 229.8 88.6209C223.153 90.6442 213.055 94.1094 212.078 95.1699C211.101 96.2304 210.729 97.1885 210.827 98.4258C210.925 99.663 226.986 153.776 228.037 153.385C229.088 152.995 244.163 149.288 243.874 148.613C243.837 148.525 245.302 144.748 244.763 143.18C244.563 142.604 233.762 147.236 233.051 146.999C231.721 146.567 215.148 99.049 215.906 98.5514Z",
    fill: "#D5DFE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M211.409 95.2864C209.134 97.2074 209.265 100.584 210.213 103.366C211.162 106.147 225.47 148.292 225.721 148.646C227.116 150.595 228.177 148.823 228.079 147.897C228.037 147.488 211.334 100.412 211.213 98.5934C211.137 97.4873 211.202 96.3758 211.409 95.2864Z",
    fill: "#38455B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M245.198 122.019C250 119.759 251.844 113.573 249.316 108.201C246.788 102.829 240.846 100.307 236.044 102.566C231.242 104.826 229.398 111.012 231.926 116.384C234.454 121.756 240.396 124.278 245.198 122.019Z",
    fill: "#3FC0E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M214.181 107.966L211.302 99.5103L211.316 96.2358",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M211.316 96.2351C212.404 94.5374 218.632 92.1234 221.046 91.3606L211.316 96.2351Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M287.429 107.342C287.541 107.602 292.606 130.826 310.993 138.04C325.523 143.738 335.891 137.547 335.891 137.547C337.389 151.794 337.751 168.688 339.235 193.525C341.049 223.484 342.384 239.447 342.384 239.447H255.8L256.568 213.865C256.568 213.865 250.056 222.349 241.647 222.056C232.642 221.745 226.618 216.107 221.107 204.154C213.664 188.018 205.943 154.808 205.943 154.808L228.59 145.92L237.66 175.985C237.66 175.985 240.786 148.789 245.93 134.859C251.075 120.928 257.438 114.272 266.824 111.244C276.21 108.216 287.429 107.342 287.429 107.342Z",
    fill: "url(#paint0_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M268.833 62.6111C267.168 59.9041 258.54 69.6718 261.33 73.7463C262.763 75.8347 266.024 75.0859 267.377 72.5556C269.238 69.0671 269.438 63.5925 268.833 62.6111Z",
    stroke: "#38455B",
    strokeWidth: 0.754432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M271.345 59.0903C267.624 66.03 265.526 71.3837 264.461 76.9001C263.396 82.4165 261.935 88.7329 264.094 91.7842C266.317 94.9191 272.257 94.1098 273.861 94.2866C275.466 94.4633 276.28 98.5332 278.945 108.492C278.945 108.492 286.917 107.026 287.545 107.603C287.545 107.603 283.234 98.9751 283.824 84.6631C284.169 76.2908 288.731 63.537 288.731 63.537C288.731 63.537 280.113 63.8579 275.792 61.7881C274.202 61.0795 272.708 60.173 271.345 59.0903Z",
    fill: "#F7CA7C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M320.462 140.004C303.871 138.292 296.411 128.068 290.271 114.533C284.931 102.765 283.206 93.6303 283.824 83.5743C284.443 73.5182 288.727 63.5366 288.727 63.5366C281.685 63.8342 276.671 62.383 271.345 59.0899C261.475 52.9781 265.763 46.778 276.461 45.4012C281.364 44.7733 295.997 42.3593 302.011 42.8104C308.025 43.2616 317.895 47.9268 318.495 56.7643C319.095 65.6017 313.597 83.1929 317.141 89.4488C320.686 95.7048 332.709 94.835 342.37 92.3698C351.673 89.9884 356.077 92.2722 357.431 101.589C358.975 112.263 347.877 142.827 320.462 140.004Z",
    fill: "#CBDBFA",
    stroke: "#38455B",
    strokeWidth: 0.754432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M264.624 67.8018C277.796 72.0949 281.833 73.4763 281.833 73.4763",
    stroke: "#38455B",
    strokeWidth: 0.754432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M262.796 161.627C259.894 185.875 259.415 186.209 256.708 213.387",
    stroke: "#5E646D",
    strokeWidth: 0.754432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M228.59 145.929C229.879 138.715 232.679 120.566 231.004 117.989C229.33 115.412 226.753 117.473 226.237 119.794C225.72 122.115 223.79 128.682 222.246 130.227C220.702 131.771 219.153 129.324 218.525 127.524C217.897 125.724 211.948 108.687 211.948 108.687C211.791 112.567 211.193 116.416 210.167 120.161C208.492 126.347 208.697 129.971 208.827 134.869C208.957 139.766 210.92 152.85 210.92 152.85L228.59 145.929Z",
    fill: "#F7CA7C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M266.824 111.254C262.242 109.115 256.74 102.882 255.196 103.068C253.651 103.254 253.228 104.036 253.461 105.482C253.693 106.929 256.679 110.087 257.456 111.124C258.246 112.266 258.944 113.468 259.545 114.719C259.545 114.719 262.801 112.673 264.289 112.18C266.108 111.575 266.824 111.254 266.824 111.254Z",
    fill: "#F7CA7C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M219.469 125.734C214.618 106.52 210.539 100.115 211.316 96.2358C212.092 92.3567 247.377 83.8402 251.005 84.4262C252.81 84.7193 258.735 103.366 259.703 105.697",
    stroke: "#38455B",
    strokeWidth: 0.754432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M241.795 149.06C241.795 149.06 241.209 149.414 230.73 152.13",
    stroke: "#38455B",
    strokeWidth: 0.754432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M288.727 63.5363C300.476 61.4851 295.88 55.2663 293.099 56.6617C291.001 57.7082 288.727 63.5363 288.727 63.5363Z",
    fill: "white",
    stroke: "#38455B",
    strokeWidth: 0.754432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M229.972 151.893C234.623 150.697 240.023 148.902 242.414 148.297L241.972 150.995C241.302 151.46 230.628 154.939 230.548 154.284L229.972 151.893Z",
    fill: "#38455B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M211.692 114.073C211.776 120.059 213.985 129.074 213.985 129.074",
    stroke: "#38455B",
    strokeWidth: 0.754432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M209.748 122.445C209.631 127.711 209.631 129.771 209.631 129.771",
    stroke: "#38455B",
    strokeWidth: 0.754432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M237.66 175.996C237.009 186.168 234.87 201.387 234.87 201.387",
    stroke: "#5E646D",
    strokeWidth: 0.754432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M237.144 114.319L242.558 116.124L243.298 107.017",
    stroke: "white",
    strokeWidth: 1.51294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M119.569 76.3513C126.055 76.3513 131.313 71.0931 131.313 64.6068C131.313 58.1205 126.055 52.8623 119.569 52.8623C113.082 52.8623 107.824 58.1205 107.824 64.6068C107.824 71.0931 113.082 76.3513 119.569 76.3513Z",
    fill: "#FA8CB4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M179.25 93.4681C182.869 93.4681 185.803 90.534 185.803 86.9145C185.803 83.295 182.869 80.3608 179.25 80.3608C175.63 80.3608 172.696 83.295 172.696 86.9145C172.696 90.534 175.63 93.4681 179.25 93.4681Z",
    fill: "#8A7CB2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M224.259 2.1847L211.771 14.6729L224.259 27.161L236.747 14.6729L224.259 2.1847Z",
    fill: "#3FC0E9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M236.149 56.3691C237.734 56.3691 239.019 55.0842 239.019 53.4992C239.019 51.9143 237.734 50.6294 236.149 50.6294C234.564 50.6294 233.279 51.9143 233.279 53.4992C233.279 55.0842 234.564 56.3691 236.149 56.3691Z",
    fill: "#E58BB4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6512 74.1735C65.2362 74.1735 66.5211 72.8886 66.5211 71.3037C66.5211 69.7187 65.2362 68.4338 63.6512 68.4338C62.0662 68.4338 60.7814 69.7187 60.7814 71.3037C60.7814 72.8886 62.0662 74.1735 63.6512 74.1735Z",
    fill: "#8A7CB2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2745 114.592L85.6884 122.154L88.3191 125.836L98.9051 118.274L96.2745 114.592Z",
    fill: "#3FC0E9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M179.531 43.4381L173.026 32.1714L169.107 34.4342L175.611 45.7009L179.531 43.4381Z",
    fill: "#8A7CB2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M435.505 63.4381L429 52.1714L425.081 54.4342L431.585 65.7009L435.505 63.4381Z",
    fill: "#8A7CB2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M123.09 24.7311C124.675 24.7311 125.96 23.4463 125.96 21.8613C125.96 20.2763 124.675 18.9915 123.09 18.9915C121.505 18.9915 120.22 20.2763 120.22 21.8613C120.22 23.4463 121.505 24.7311 123.09 24.7311Z",
    fill: "#3FC0E9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M144.839 122.082C146.424 122.082 147.709 120.797 147.709 119.212C147.709 117.627 146.424 116.343 144.839 116.343C143.254 116.343 141.97 117.627 141.97 119.212C141.97 120.797 143.254 122.082 144.839 122.082Z",
    fill: "#E58BB4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8698 175.74C57.4548 175.74 58.7397 174.455 58.7397 172.87C58.7397 171.285 57.4548 170 55.8698 170C54.2849 170 53 171.285 53 172.87C53 174.455 54.2849 175.74 55.8698 175.74Z",
    fill: "#E58BB4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M269.238 72.5045C264.642 74.4301 266.884 78.4953 268.921 79.1697C270.959 79.8442 275.075 78.4581 274.503 75.5836C274.149 73.7743 271.889 71.3882 269.238 72.5045Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M323.136 117.681C341.998 112.67 351.957 99.4169 349.523 84.8333C346.53 66.871 325.109 72.1342 316.595 59.0139C294.469 24.9028 337.865 -7.62976 374.97 2.51089C412.433 12.7668 429.788 43.4548 425.309 80.6077C421.828 109.482 408.744 128.939 380.219 142.746C336.061 164.092 282.613 135.146 286.169 123.817C289.707 112.559 300.008 123.817 323.136 117.681Z",
    fill: "#D7ECF4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M319.097 35.4305C318.879 36.7607 319.611 37.0356 320.072 36.7607C320.533 36.4858 320.835 34.8851 320.369 34.5082C319.904 34.1313 319.234 34.5792 319.097 35.4305Z",
    fill: "#38455B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M324.781 34.4778C324.56 35.808 325.269 36.0385 325.752 35.808C326.16 35.6262 326.519 33.9279 326.049 33.551C325.579 33.1741 324.919 33.6264 324.781 34.4778Z",
    fill: "#38455B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M321.328 39.9541C321.962 40.5926 323.598 40.2024 324.653 38.9653",
    stroke: "#38455B",
    strokeWidth: 0.719196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M328.577 36.1528C326.621 36.9686 327.575 38.6979 328.444 38.9861C329.313 39.2743 331.06 38.6846 330.82 37.4608C330.674 36.7026 329.712 35.7094 328.577 36.1528Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M317.079 37.5323C315.128 38.3526 316.077 40.0818 316.946 40.37C317.816 40.6583 319.563 40.0641 319.323 38.8403C319.181 38.0732 318.215 37.0401 317.079 37.5323Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 275.866,
    y1: 56.4149,
    x2: 273.275,
    y2: 270.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D6E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8BBBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#83C3EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ED7C3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlluConfirmation);
export default __webpack_public_path__ + "static/media/illu-confirmation.f7a634ba98009d749d416c298a918e15.svg";
export { ForwardRef as ReactComponent };